// Modal for exam rules/instructions
import React from 'react';
import { Button } from '@mui/material';


const defaultInstructions = [
  'Read all questions carefully before answering.',
  'You can mark questions for review and return to them later.',
  'Do not refresh or close the browser during the exam.',
  'Click Submit when you have completed the exam.',
  'Your answers will be auto-submitted when the timer ends.',
];


const InstructionsModal = ({ open, onStart, onClose, instructions = defaultInstructions }) => {
  if (!open) return null;

  const handleStart = (e) => {
    e.stopPropagation();
    try {
      // debug log helps trace clicks in runtime
      // eslint-disable-next-line no-console
      console.info('[InstructionsModal] Start clicked');
      if (typeof onStart === 'function') onStart();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('[InstructionsModal] onStart error', err);
    }
  };

  const handleClose = (e) => {
    e.stopPropagation();
    if (typeof onClose === 'function') onClose();
  };

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: '#0008', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <div style={{ background: '#fff', borderRadius: 12, padding: 32, minWidth: 340, maxWidth: 520, textAlign: 'left', boxShadow: '0 4px 32px #0002', position: 'relative' }}>
        <div style={{ fontWeight: 700, fontSize: 22, marginBottom: 16 }}>Exam Instructions</div>
        <ul style={{ color: '#334155', fontSize: 16, marginBottom: 24 }}>
          {instructions.map((rule, idx) => (
            <li key={idx} style={{ marginBottom: 8 }}>{rule}</li>
          ))}
        </ul>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
          <Button variant="outlined" onClick={handleClose} sx={{ textTransform: 'none' }}>Close</Button>
          <Button variant="contained" onClick={handleStart} sx={{ textTransform: 'none' }}>Start Exam</Button>
        </div>
      </div>
    </div>
  );
};

export default InstructionsModal;
